import MoreDetailsButton from './MoreDetailsButton'

export default MoreDetailsButton
